export const DonationId = 'foundation';
